import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage'; // Add this import
import PasswordResetPage from './pages/PasswordResetPage';
import DashboardPage from './pages/DashboardPage';
import LeaveRequestsPage from './pages/LeaveRequestsPage';
import LeaveRequestForm from './pages/LeaveRequestForm';
import LeaveRequestReviewPage from './pages/LeaveRequestReviewPage';
import CalendarPage from './pages/CalendarPage';
import ProfilePage from './pages/ProfilePage';
import StaffManagementPage from './pages/StaffManagementPage';
import AdminPage from './pages/AdminPage';
import EditUserPage from './pages/EditUserPage';
import UserLeaveHistoryPage from './pages/UserLeaveHistoryPage';

// Placeholder for pages not yet implemented
const UnauthorizedPage = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="p-8 bg-white shadow-md rounded-md max-w-md">
      <h1 className="text-2xl font-bold text-red-600 mb-4">Unauthorized Access</h1>
      <p className="mb-6">You do not have permission to access this page.</p>
      <a href="/" className="text-blue-600 hover:underline">Return to dashboard</a>
    </div>
  </div>
);

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} /> {/* Add this route */}
          <Route path="/reset-password" element={<PasswordResetPage />} />
          <Route path="/unauthorized" element={<UnauthorizedPage />} />
          
          {/* Protected routes for all authenticated users */}
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/leave-requests" element={<LeaveRequestsPage />} />
            <Route path="/leave-requests/new" element={<LeaveRequestForm />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/profile" element={<ProfilePage />} />
          </Route>
          
          {/* Protected routes for managers and admins */}
          <Route element={<ProtectedRoute requiredRoles={['manager', 'admin']} />}>
            <Route path="/staff" element={<StaffManagementPage />} />
            <Route path="/leave-requests/review/:id" element={<LeaveRequestReviewPage />} />
            <Route path="/admin/edit-user/:id" element={<EditUserPage />} />
            <Route path="/staff/leave-history/:id" element={<UserLeaveHistoryPage />} />
          </Route>
          
          {/* Protected routes for admins only */}
          <Route element={<ProtectedRoute requiredRoles={['admin']} />}>
            <Route path="/admin" element={<AdminPage />} />
          </Route>
          
          {/* Redirect to dashboard if path doesn't match any routes */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;